export class BlobUrlSlot {
  #url: string | undefined;
  readonly #create: (blob: Blob) => string;
  readonly #revoke: (url: string) => void;

  constructor(
    create: (blob: Blob) => string = (blob) => URL.createObjectURL(blob),
    revoke: (url: string) => void = (url) => URL.revokeObjectURL(url),
  ) {
    this.#create = create;
    this.#revoke = revoke;
  }

  replace(blob: Blob): string {
    const next = this.#create(blob);
    this.clear();
    this.#url = next;
    return next;
  }

  clear(): void {
    if (this.#url) {
      this.#revoke(this.#url);
      this.#url = undefined;
    }
  }

  get current(): string | undefined {
    return this.#url;
  }
}
